function GeocoderModule() {
    var self = this;
    self.markers = [];
    self.map = null;
    self.geocoder = null;
    self.address = null;

    // Google Maps puo' arrivare a richiesta, dopo gli script della pagina (tgMaps in
    // lib/restfool.js). Dove c'e' gia', come su quasi tutte le pagine, la funzione viene
    // eseguita subito, come prima.
    function whenMaps(fn, load) {
        if (!window.tgMaps) {
            fn();
        } else if (load) {
            tgMaps.ready(fn);
        } else {
            tgMaps.onReady(fn);
        }
    }

    self.geocode = function (callback) {
        whenMaps(function () {
            if (!self.geocoder) {
                self.geocoder = new google.maps.Geocoder();
            }
            self.geocoder.geocode({'address': self.address.toString()}, function (results, status) {
                if (status === google.maps.GeocoderStatus.OK) {
                    var location = results[0].geometry.location;
                    if (self.map) {

                        self.map.setCenter(location);
                        removeMarkers();
                        addMarker(location.lat(), location.lng(), 16);
                        showMarkers();
                    }
                    if (callback) {
                        callback({
                            lat: location.lat(),
                            lon: location.lng()
                        });
                    }
                } else {
                    callback(null);
                }
            });
        }, true);
    };

    function showMarkers() {
        for (var i in self.markers) {
            self.markers[i].setMap(self.map);
        }
    }

    function removeMarkers() {
        for (var i in self.markers) {
            self.markers[i].setMap(null);
        }
        self.markers = [];
    }

    self.init = function (elementId, address) {
        self.address = address;

        var element = elementId ? document.getElementById(elementId) : null;

        // Maps si fa caricare solo se c'e' una mappa da disegnare adesso; altrimenti il
        // geocoder nasce quando Maps arriva, o alla prima ricerca di coordinate.
        whenMaps(function () {
            self.geocoder = new google.maps.Geocoder();

            if (element) {
                if (self.address && self.address.latitude() && self.address.longitude()) {
                    setMap(element, self.address.latitude(), address.longitude(), 16);
                    addMarker(self.address.latitude(), self.address.longitude(), 16);
                } else {
                    setMap(element, 41.8929163, 12.4825198, 14);
                    addMarker(41.8929163, 12.4825198, 14);
                }
                showMarkers();
            }
        }, !!element);

        return self;
    };

    function handleEvent(event) {
        self.address.latitude(parseFloat(event.latLng.lat()));
        self.address.longitude(parseFloat(event.latLng.lng()));
    }

    function addMarker(lat, lon, zoom, draggable) {
        var myLatLng = new google.maps.LatLng(lat, lon);
        if (!draggable)
            draggable = true;

        var marker = new google.maps.Marker({
            map: self.map,
            position: myLatLng,
            draggable: draggable
        });

        if (draggable) {
            marker.addListener('dragend', handleEvent);
        }

        self.markers.push(marker);
        return marker;
    }

    function setMap(element, lat, lon, zoom) {
        var myLatLng = new google.maps.LatLng(lat, lon);
        var mapOptions = {
            zoom: zoom,
            center: myLatLng,
        };
        self.map = new google.maps.Map(element, mapOptions);
        return self.map;
    }
}